export const getGraphqlUrl = () => {
  if (typeof document === "undefined") {
    return process.env.CPRM_GRAPH_URL + "/graphql";
  }
  // @ts-ignore
  return window.__CPRM_GRAPH_URL__ + "/graphql";
};

export const getGraphqlApiBaseUrl = () => {
  if (typeof document === "undefined") {
    return process.env.CPRM_GRAPH_URL;
  }
  // @ts-ignore
  return window.__CPRM_GRAPH_URL__;
};

export const getGraphqlContactAuthUrl = () => {
  if (typeof document === "undefined") {
    return process.env.CPRM_GRAPH_URL + "/contactauth/login";
  }
  // @ts-ignore
  return window.__CPRM_GRAPH_URL__ + "/contactauth/login";
};
